
const digest = '9e73308fb70d99f5e9c7746c3a76bc0668f8242caa1beeaf86351ce573b1912a';
const classes = {"eventsList":"_eventsList_1vdaa_1"};
const css = `._eventsList_1vdaa_1 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  